import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Ensures only one searchable dropdown panel is open at a time (e.g. table inline edit row). */
@Injectable({ providedIn: 'root' })
export class SearchableDropdownCoordinatorService {
  private static nextInstanceId = 0;
  private readonly opened = new Subject<string>();

  readonly opened$ = this.opened.asObservable();

  createInstanceId(): string {
    SearchableDropdownCoordinatorService.nextInstanceId += 1;
    return `searchable-dropdown-${SearchableDropdownCoordinatorService.nextInstanceId}`;
  }

  notifyOpened(instanceId: string): void {
    this.opened.next(instanceId);
  }
}
